import { MemoizedSelector, createSelector, select } from '@ngrx/store';
import { Observable } from 'rxjs';

export class Selector {

    public static selectByPath(path: string): (source$: Observable<any>) => Observable<any> {

        const slices = path.split('.');

        const sel = slices
            .slice(1)
            .reduce(
                (acc, current) => createSelector( acc, state => state[current]),
                createSelector( state => state[slices[0]], state => state)
            );


        return select(sel);

    }
}
